import { useEffect, useState } from "react";
import axios from "../../utils/axios";
import { DragDropContext, Draggable } from 'react-beautiful-dnd'
import StrictModeDroppable from "../shared/StrictModeDroppable";
import PrimaryButton from "../shared/buttons/PrimaryButton";
import TableUpdateActionButton from "../shared/buttons/TableUpdateActionbutton";
import { useMemo } from "react";
import { createRef } from "react";
import { Switch } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import IconButton from "../shared/buttons/IconButton";
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import useAuth from "../../hooks/useAuth";
import {useNotifications} from 'reapop';

const articleCategoryUrl = 'article/category';

const ArticleCategoryOrder = ({catUpdated, setCatUpdated, listArticles, getArticleList}) => {
    const {auth} = useAuth();
    const [categories, setCategories] = useState(null);
    const [categoryEditableIdx, setCategoryEditableIdx] = useState(null);
    const [canSaveCatOrder, setCanSaveCatOrder] = useState(false);
    const [articles, setArticles] = useState(listArticles);
    const {notify} = useNotifications();

    const refsById = useMemo(() => {
        const refs = {};
        categories?.forEach((item) => {
            refs[item.id] = createRef(null);
        })
        return refs;
    }, [categories]);


    const currentCategoryDom = (index) => {
        return refsById[index].current
    }

    const saveCategoryOrder = async () => {
        try {
            await axios.post(`${articleCategoryUrl}/bulk_update`, categories);
            setCanSaveCatOrder(false);
            notify('Ordre des groupes article modifié avec succès', 'info', {dismissAfter: 5000});
        } catch (error) {
            // console.error(error);
        }
    }

    const changeCategoryOrder = (category, order) => {
        return category.order = categories.length - order;
    };

    const handleDragDrop = (result) => {
        if (!result?.destination) return;

        const categoryItems = Array.from(categories); // need to change array reference to use in setState
        const reorderItem = categoryItems.splice(result?.source?.index, 1);
        categoryItems.splice(result?.destination?.index, 0, ...reorderItem);
        categoryItems.map((items, idx) => changeCategoryOrder(items, idx)) // using the same counter as the backend
        
        setCategories(categoryItems);
        setCanSaveCatOrder(true);
    } 

    const getCategories = async () => {
        try {
            let config = {
                headers: {
                  'Authorization': `Bearer ${auth?.accessToken}`
                }
              }
            const response = await axios.get(articleCategoryUrl, config);
            const sortedCategories = response.data.sort((a, b) => b.order - a.order);
            
            setCategories(sortedCategories)
            setCatUpdated(false);
        } catch (error) {
            setCategories([])
            // console.error(error)
        }

    }

    useEffect(() => {
        getCategories();
    }, []);

    useEffect(() => {
        if (!catUpdated) return;
        getCategories();
    }, [catUpdated]);

    useEffect(() => {
        setArticles(listArticles);
    }, [listArticles]);


    const makeCategoryReadOnly = (categoryContentDom) => {
        if(categoryContentDom?.target) {
            categoryContentDom.target.contentEditable = 'false'
        } else {
            categoryContentDom.contentEditable = 'false'
        }
        setCategoryEditableIdx(null);
    }

    const makeCategoryEditable = (categoryId) => {
        const categoryContentDom = currentCategoryDom(categoryId);
        categoryContentDom.contentEditable = 'true'
        categoryContentDom.focus();
        window.getSelection().selectAllChildren(categoryContentDom);

        setCategoryEditableIdx(categoryId);
    }

    const handleSubmit = async (categoryId, value, callback=()=>{}) => {
        try {
            await axios.patch(`article/category/${categoryId}`, value);
            callback();
            setCatUpdated(true);
            getArticleList();     
            notify('Groupe article modifié avec succès', 'info', {dismissAfter: 5000});       
        } catch (error) {
            // console.error(error);
        }
    }

    const saveCategoryEdit = async (categoryId) => {
        const categoryContentDom = currentCategoryDom(categoryId);
        const value = categoryContentDom.innerText;

        if (!value) return;

        const callback = () => makeCategoryReadOnly(categoryContentDom);
        handleSubmit(categoryId, {name: value}, callback);
    }

    const handleDelete = async (categoryId) => {
        if (window.confirm('voulez vous supprimer le groupe?')) {
            try {
                var relatedArticles = articles.filter(article => article.group.id == categoryId);
                relatedArticles = relatedArticles.forEach(async(article) => {
                    var displayArray = article.display.split(',');
                    var index = displayArray.indexOf("group");
                    if (index > -1) {
                        displayArray.splice(index, 1);
                    }
                    article.display = displayArray.join(',');
                    article.group = article.group.id;
                    await axios.patch(`/article/${article.id}`, article);
                });
                await axios.delete(`article/category/${categoryId}`);                                  
                getArticleList();         
                setCatUpdated(true);
                notify('Le groupe article a été supprimé', 'info', {dismissAfter: 5000});
            } catch (error) {
                console.error(error)
            }
        }
    }


    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: '0.5em',
        margin: '0.5em 0',
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'space-between',
        border: isDragging ? "2px solid rgb(16,87,200)" : "1px solid rgb(0,0,0,0.3)",
        ...draggableStyle,
    });
    
    const getListStyle = isDraggingOver => ({
        margin: '1em 0',
    });
    
    const contentStyle = {
        flex: 1,
        display: 'flex',
        marginRight: '1em',
        alignItems: 'center'
    }

    return (
        <>
            {categories &&
                <div>
                    <p style={{fontWeight: 'bold', opacity: '0.7'}}>Modifier les groupes</p>
                        <DragDropContext onDragEnd={handleDragDrop}>
                            <StrictModeDroppable 
                            droppableId="articleGroup"
                            renderClone={(provided, snapshot, rubric) => (
                                <div 
                                    {...provided.draggableProps} 
                                    {...provided.dragHandleProps} 
                                    ref={provided.innerRef}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                >
                                    <div 
                                        // contentEditable={categoryEditableIdx === item.id}
                                        // autoFocus={categoryEditableIdx === item.id}
                                        style={contentStyle}
                                        ref={refsById[categories[rubric.source.index].id]}
                                        suppressContentEditableWarning={true}
                                        onBlur={makeCategoryReadOnly}
                                    >
                                        {categories[rubric.source.index].name}
                                    </div>
                                    {categoryEditableIdx !== categories[rubric.source.index].id ?
                                        <div>
                                            <TableUpdateActionButton clickHandler={makeCategoryEditable} idx={categories[rubric.source.index].id} />
                                            <Switch checked={categories[rubric.source.index].is_active} onChange={(_, value) => handleSubmit(categories[rubric.source.index].id, {is_active: value})}  size="small" />
                                            <IconButton color={'error'} onClick={() => handleDelete(categories[rubric.source.index].id)}><DeleteOutlineIcon/></IconButton>
                                        </div> :
                                        <IconButton onClick={() => saveCategoryEdit(categories[rubric.source.index].id)}><SaveOutlinedIcon/></IconButton>
                                    }
                                </div>
                              )}
                              >
                                {(provided, snapshot) => (
                                    <div 
                                        {...provided.droppableProps} 
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {
                                            categories.map((item, idx) => (
                                                <Draggable 
                                                    key={`${item.id}`} 
                                                    draggableId={`${item.id}`} 
                                                    index={idx}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div 
                                                            {...provided.draggableProps} 
                                                            {...provided.dragHandleProps} 
                                                            ref={provided.innerRef}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}
                                                        >
                                                            <div 
                                                                // contentEditable={categoryEditableIdx === item.id}
                                                                // autoFocus={categoryEditableIdx === item.id}
                                                                style={contentStyle}
                                                                ref={refsById[item.id]}
                                                                suppressContentEditableWarning={true}
                                                                onBlur={makeCategoryReadOnly}
                                                            >
                                                                {item.name}
                                                            </div>
                                                            {categoryEditableIdx !== item.id ?
                                                                <div>
                                                                    <TableUpdateActionButton clickHandler={makeCategoryEditable} idx={item.id} />
                                                                    <Switch checked={item.is_active} onChange={(_, value) => handleSubmit(item.id, {is_active: value})}  size="small" />
                                                                    <IconButton color={'error'} onClick={() => handleDelete(item.id)}><DeleteOutlineIcon/></IconButton>
                                                                </div> :
                                                                <IconButton onClick={() => saveCategoryEdit(item.id)}><SaveOutlinedIcon/></IconButton>
                                                            }
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))
                                        }
                                       {provided.placeholder}
                                    </div>
                                )}
                            </StrictModeDroppable>
                        </DragDropContext>
                        <PrimaryButton onClick={saveCategoryOrder} disabled={!canSaveCatOrder} >Confirmer le nouvel ordre</PrimaryButton>
                </div>
            }
        </>
        )
}

export default ArticleCategoryOrder